import { render, staticRenderFns } from "./gradeResultadosProdutos.vue?vue&type=template&id=a2c1a5c0&scoped=true"
import script from "./gradeResultadosProdutos.vue?vue&type=script&lang=js"
export * from "./gradeResultadosProdutos.vue?vue&type=script&lang=js"
import style0 from "./gradeResultadosProdutos.vue?vue&type=style&index=0&id=a2c1a5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c1a5c0",
  null
  
)

export default component.exports